import { getCookie } from "@Src/utils/cookie.utils";

const XSRF_HEADER_NAME = "__Secure-adc.x-xsrf-token";
const XSRF_COOKIE_NAME = "adc_d_meta";

export const doFetch = (url) => {
  return fetch(url)
    .then((response) => jsonOrError(response))
    .then((data) => data)
    .catch(rejectErrors);
};

export const doPostFetch = (url, body) => {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    credentials: "same-origin",
    headers: {
      [XSRF_HEADER_NAME]: getXtoken(),
      "Content-Type": "application/json",
    },
  })
    .then((response) => jsonOrError(response))
    .then((data) => data)
    .catch(rejectErrors);
};

export const doPutFetch = (url, body) => {
  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(body),
    credentials: "same-origin",
    headers: {
      [XSRF_HEADER_NAME]: getXtoken(),
      "Content-Type": "application/json",
    },
  })
    .then((response) => jsonOrError(response, url, "put"))
    .then((data) => data)
    .catch(rejectErrors);
};

export const doDeleteFetch = (url, body) => {
  return fetch(url, {
    method: "DELETE",
    body: JSON.stringify(body),
    credentials: "same-origin",
    headers: {
      [XSRF_HEADER_NAME]: getXtoken(),
      "Content-Type": "application/json",
    },
  })
    .then((response) => jsonOrError(response))
    .then((data) => data)
    .catch(rejectErrors);
};

function jsonOrError(response) {
  if (response.ok) {
    return response.json();
  } else {
    const { status, statusText } = response;
    return response.json().then((data) => {
      return Promise.reject({ statusText, status, data });
    });
  }
}

function rejectErrors(error) {
  console.log(error);
  return Promise.reject(error);
}

function getXtoken() {
  const token = getCookie(XSRF_COOKIE_NAME);
  return token;
}
